import hackathonLogo from './Assets/CoAfinaLogoW.png';
// Importing all sponsors logos from Assets
/** Put all your Team member image inside folder `Team Images`
 * and import them like in the above and update src in TeamInfo
 * or you can provide a cloud link in src also
 */

import boy from './Assets/boy.png';
import ccVen from './Assets/sponsorsLogos/ccVen.png';
import cedia from './Assets/sponsorsLogos/cedia.png';
import inait from './Assets/sponsorsLogos/inait.png';
import laconga from './Assets/sponsorsLogos/laconga.png';
import ols from './Assets/sponsorsLogos/ols.png';
import pwfICTP from './Assets/sponsorsLogos/pwfICTP.png';
import redClara from './Assets/sponsorsLogos/redClara.png';
import ssi from './Assets/sponsorsLogos/ssi.png';

/** Put all your sponsors logo inside folder `sponsorLogos`
 * and import them in the above and update `src` in sponsorLogos
 * or you can provide a cloud link in src
 */

// Importing all Team members images  from Assets

import alex from './Assets/teami/alex.png';
import ariana from './Assets/teami/ariana.png';
import arturo from './Assets/teami/arturo.png';
import dennis from './Assets/teami/dennis.png';
import estefania from './Assets/teami/estefania.png';
import jal from './Assets/teami/jal.png';
import luz from './Assets/teami/luz.png';
import reina from './Assets/teami/reina.png';
import yank from './Assets/teami/yank.png';
import ysa from './Assets/teami/ysa.png';

const TOP_SECTION = {
  TITLE: 'Co-Afina 2023',
  Typed_effect: [
    'Retos de Ciencia y Educación',
    '¡Volvimos a sonar juntos!',
    'Construimos comunidad'
  ],
  SHORT_DESCRIPTION:
    'Más de 20 áreas del conocimiento dialogaron en forma colaborativa para resolver retos en Ciencia y Educación durante #CoAfina2023 del 20 al 22 de octubre.',
  IMG_SRC: boy,
  DISCORD_LINK: 'https://discord.gg/UHRQZFEs',
  JUDGES_FORM_LINK: 'https://forms.gle/3ZuhKDKGVrGX55wR8',
  TEAM_FORM_LINK:
    'https://discord.com/channels/949325214746026055/949325214746026063',
  CHALLENGERS_FORM_LINK: 'https://forms.gle/DZQ5J73EPNndQ8o2A',
  HACKERS_REGISTRATION_FORM_LINK: 'https://forms.gle/w6RJg84tn9L2UjxM9'
};

const SOCIALS = {
  instagram: 'https://www.instagram.com/lacongaphysics/',
  facebook: 'https://www.facebook.com/lacongaphysics/',
  discord: 'https://discord.gg/UHRQZFEs',
  twitter: 'https://twitter.com/lacongaphysics',
  email: 'mailto:contacto@laconga.redclara.net',
  agenda:
    'https://calendar.google.com/calendar/embed?src=035673cbe2911a2d70516a9dac7701ac7047aa807c90a17b5fa8f77b460c7f99%40group.calendar.google.com&ctz=Europe%2FParis',
  mail: 'contacto@laconga.redclara.net'
};

const MIDDLE_SECTION = {
  TITLE: '¡Volvimos a sonar juntos!',
  LONG_DESCRIPTION:
    'El hackathon latinoamericano sobre retos de Ciencia y Educación regresó este año con nuevos retos. Desde LA-CoNGA physics nos seguimos planteando interrogantes que relacionan los datos abiertos con la educación y con el impacto social del conocimiento científico ¿Cómo pueden aportar los datos abiertos para mejorar la sociedad en temas como: educación, salud, agricultura, ambiente, ciudadanía, gobernanza, opinión pública? ¿Cómo podría aportar la Inteligencia Artificial? ¿Qué iniciativas podrían aplicar para optimizar la enseñanza de la ciencia?  Volvimos a sonar juntos para resolver retos en ciencia y educación usando datos abiertos.',
  CDC_SHORT:
    'Quienes organizamos Co-Afina 2023 estamos comprometidos.as a fomentar un ambiente abierto, seguro y amigable y a garantizar la participación de todas las personas en nuestras actividades y espacios virtuales sin importar edad, género, orientación sexual, discapacidad, apariencia física, nacionalidad, raza, etnia, religión (o falta de ella), ideología u opciones tecnológicas. Todas las personas que participen en Co-Afina, incluidos los miembros del equipo coordinador, colaboradores, equipo asesor y participantes, deben aceptar y respetar el código de conducta disponible en',
  CDC_URL: 'https://laconga.redclara.net/hackathon-coc',
  LOGO: hackathonLogo
};

const FOOTER = {
  VOLUNTEERING_FORM: {
    required: true,
    src: 'https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAN__jZdNhdUNFBQME44TzJZWDc2UFgwTUtLN0xDQVYyUi4u'
  },
  JOIN_TEAM: {
    required: true,
    src: 'mailto:contacto@laconga.redclara.net'
  },
  Privacy_policy: {
    required: true,
    src: ''
  },
  Terms_of_use: {
    required: true,
    src: ''
  }
};

/** SCHEDULE
 *
 * INSTRUCTIONS
 *
 * Date format : 8-11-2021, 18-11-2021 (without trailing zeros)
 */

const calenderStartingDate = {
  month: 10,
  year: 2023
};

const schedule = [
  {
    day: '20-10-2023',
    events: [
      {
        title: 'Día 1',
        timings: '9 AM - 11:59 Pm',
        link: 'https://google.com'
      }
    ]
  },
  {
    day: '21-10-2023',
    events: [
      {
        title: 'Día 2',
        timings: '00:00 AM - 11:59 Pm',
        link: 'https://google.com'
      },
      {
        title: 'Intro to deep learning',
        timings: '00:00 AM - 5 Pm',
        link: 'https://google.com'
      }
    ]
  },
  {
    day: '22-10-2023',
    events: [
      {
        title: 'Día 3',
        timings: '00:00 AM - 5 Pm',
        link: 'https://google.com'
      }
    ]
  }
];

/** ICON
 *
 * icons are from fontawesome visit = https://fontawesome.com
 * and just copy paste icon links and update icon in Prizeinfo
 *
 * INSTRUCTIONS
 *
 * Insert only 3 or less then 3 prizes per array in `Prizeinfo`, you can
 * create as many arrays you want all prizes will be rendered
 * in a group of 3.
 */

const Prizeinfo = [
  [
    //Array 1
    {
      icon: <i className="first fas fa-4x fa-trophy"></i>,
      type: 'Primer Lugar',
      content: 'DarkArmy 🇨🇴',
      video: 'https://youtu.be/0019wrS2c1s',
      integrantes:
        'Jorge Jaimes, Camilo Carvajal, Brayan Barajas, Paula Uzcátegui'
    },
    {
      icon: <i className=" second fas fa-4x fa-medal"></i>,
      type: 'Segundo Lugar',
      content: 'Chaotic Coders 🇪🇨',
      video:
        'https://drive.google.com/file/d/1zPQp5xugo6JtGDWkc4kizEAm0v2IqQUd/view',
      integrantes:
        'Arianna Paredes, Mateo Carpio, Jordan Zambrano, Kevin Robalino'
    },
    {
      icon: <i className=" third fas fa-4x fa-skiing-nordic"></i>,
      type: 'Tercer Lugar',
      content: 'CongApps 🇻🇪🇨🇴🇵🇪 ',
      video: 'https://youtu.be/RpCdR079dR4',
      integrantes: 'Steven Rico, Adrian Vasquez, Omar Medina'
    }
  ],
  [
    {
      type: ' ',
      content: ''
    },
    {
      icon: <i className=" third fas fa-4x fa-skiing-nordic"></i>,
      type: 'Mención especial',
      content: 'Neotropical 🇻🇪🇪🇨',
      video: 'https://youtu.be/3nw9mDoy_jw',
      integrantes:
        'Andrés Caña, Cristian Usca, Emilio Toledo, Rubén Niño, Isabella Sánchez'
    }
  ]
];

/** Instructions
 * Insert only 3 or less then 3 members per array in `TeamInfo`, you can
 * create as many arrays you want all team members will be rendered
 * in a group of 3.
 */

const TeamInfo = [
  [
    //Array 1
    {
      name: 'Alexander Martinez',
      role: 'Organización',
      github: 'https://www.instagram.com/mxrtinezm',
      linkedin: '',
      img: alex
    },
    {
      name: 'Ariana Moreno',
      role: 'Organización',
      github: 'https://www.instagram.com/arianamorenop',
      linkedin: '',
      img: ariana
    },
    {
      name: 'Arturo Sánchez',
      role: 'Organización',
      github: 'https://twitter.com/Arturo_RSP',
      linkedin: '',
      img: arturo
    },
    {
      name: 'Dennis Cazar',
      role: 'Organización',
      github: 'https://twitter.com/DennisCazar',
      linkedin: '',
      img: dennis
    }
  ],
  [
    //Array 2
    {
      name: 'Estefanía Sánchez',
      role: 'Organización',
      github: 'https://www.instagram.com/azul.pipita',
      linkedin: '',
      img: estefania
    },
    {
      name: 'José Antonio López',
      role: 'Organización',
      github: 'https://twitter.com/jalccs',
      linkedin: '',
      img: jal
    },
    {
      name: 'Luz Bravo',
      role: 'Organización',
      github: 'https://www.facebook.com/luz.bravo.39/',
      linkedin: '',
      img: luz
    },
    {
      name: 'Reina Camacho',
      role: 'Organización',
      github: 'https://twitter.com/rcamachotoro',
      linkedin: '',
      img: reina
    }
  ],
  [
    //Array 3
    {
      name: 'Yankady Rebolledo',
      role: 'Organización',
      github: 'https://www.instagram.com/yankadyre',
      linkedin: '',
      img: yank
    },
    {
      name: 'Ysabel Briceño',
      role: 'Organización',
      github: 'https://twitter.com/ysabelbr',
      linkedin: '',
      img: ysa
    }
  ]
];

const JudgesInfo = [
  [
    //Array 1
    {
      name: 'Ricardo Quispe',
      role: 'Jurado',
      filiation: 'UNMSM',
      img: alex
    },
    {
      name: 'Iskya García',
      role: 'Jurado',
      filiation: 'ATLAS',
      img: ariana
    },
    {
      name: 'Arturo Sánchez',
      role: 'Jurado',
      filiation: 'INAIT',
      img: arturo
    },
    {
      name: 'América Cortés',
      role: 'Jurado',
      filiation: 'UNAM',
      img: reina
    }
  ],
  [
    //Array 2
    {
      name: 'Ysabel Briceño',
      role: 'Jurado',
      filiation: 'UNAB',
      img: ysa
    },
    {
      name: 'José Antonio López',
      role: 'Jurado',
      filiation: 'UCV',
      img: jal
    }
  ]
];

const SpeakersInfo = [
  [
    {
      name: 'Andrea Sánchez Tapia',
      role: 'Speaker',
      talk: 'Haciendo ciencia en varios idiomas',
      talkVideo: 'https://twitter.com/ysabelbr',
      img: ysa
    },
    {
      name: 'Melissa Black',
      role: 'Speaker',
      talk: 'MetaDocencia: Co-creando y enseñando Ciencia Abierta en comunidad',
      talkVideo: 'https://twitter.com/ysabelbr',
      img: reina
    },
    {
      name: 'Juan Bagnato',
      role: 'Speaker',
      talk: 'Una historia de Machine Learning',
      talkVideo: 'https://twitter.com/ysabelbr',
      img: alex
    }
  ]
];

const ChallengersInfo = [
  [
    {
      name: 'David Graf',
      role: 'Retador',
      challenge:
        'Uso de PNL y LLM para el resumen de artículos y la minería de datos',
      img: yank
    },
    {
      name: 'Ricardo Quispe',
      role: 'Retador',
      challenge: 'Quantum Eco-Quest',
      img: alex
    },
    {
      name: 'Dilia Portillo',
      role: 'Retador',
      challenge:
        'ATLAS Open data y Improve data visualization + interactive resources for open data',
      img: estefania
    },
    {
      name: 'Ysabel Briceño',
      role: 'Retador',
      challenge:
        'Conoce a tu candidato(a) de acuerdo a la información pública disponible',
      img: ysa
    }
  ],
  [
    {
      name: 'Arturo Sanchez',
      role: 'Retador',
      challenge:
        'El futuro es ahora: un desafío de hackathon y Uso de PNL y LLM para el resumen de artículos y la minería de datos',
      img: arturo
    },
    {
      name: 'Yany Lizeth León Castañeda',
      role: 'Retador',
      challenge:
        'Conoce a tu candidato(a) de acuerdo a la información pública disponible',
      img: ariana
    },
    {
      name: 'John Anderson Garcia Henao',
      role: 'Retador',
      challenge:
        'Potenciar la Detección Temprana de Sepsis mediante el Análisis de Series Temporales Fisiológicas',
      img: jal
    },
    {
      name: 'Alejandro Rodriguez',
      role: 'Retador',
      challenge: 'El futuro es ahora: un desafío de hackathon',
      img: dennis
    }
  ]
];

/** Instructions
 * Only put 3 logos per array inside `sponsorLogos`, you can
 * create as many arrays you want all logos will be rendered
 * in a group of 3.
 */

const sponsorLogos = [
  [{src: pwfICTP}, {src: redClara}, {src: ccVen}], //Array 1
  [{src: cedia}, {src: laconga}, {src: inait}], //Array 2
  [{src: ssi}, {src: ols}] //Array 2
];

/** Instructions
 * Follow the strcuture provided below to add as many as FAQ's you want
 */
const frequentlyAskedQuestions = [
  [
    [
      {
        label: '¿Qué es Co-Afina?',
        content:
          'Co-Afina es un hackathon impulsado por LA-CoNGA physics (https://laconga.redclara.net/), en el que estudiantes universitarios en América Latina desarrollan soluciones en forma colaborativa para resolver problemas relacionados con temas científicos y educativos de impacto social. Seguimos los principios internacionales de Acceso Abierto. En este espacio convocamos, en una primera etapa, a personas y organizaciones a proponer retos; y en una segunda etapa convocamos a estudiantes universitarios a resolver los retos planteados.'
      }
    ],
    [
      {
        label: 'Temas centrales',
        content:
          'El hackathon Co-Afina 2023, se centra en temas de ciencia y educación superior, con una agenda que convoca intereses relacionados con la nueva universidad: Ciencia abierta, Ciencia ciudadana, Iniciativas educativas, Infraestructura compartida, Impacto social de la ciencia. ¿Tienes ideas sobre inteligencia artificial en estos tópicos? Anímate a participar como persona retadora o como estudiante.'
      }
    ]
  ]
];

export {
  ChallengersInfo,
  FOOTER,
  JudgesInfo,
  MIDDLE_SECTION,
  Prizeinfo,
  SOCIALS,
  SpeakersInfo,
  TOP_SECTION,
  TeamInfo,
  calenderStartingDate,
  frequentlyAskedQuestions,
  schedule,
  sponsorLogos
};
